<template>
  <div class="section has-text-centered">
    <div style="max-width:40em; margin: 0 auto;">
      <h1>
        <p class="is-size-1 has-text-weight-bold">
          <img alt="Twistock logo" src="pic/pengin_tiniy.png" style="height:1em;">
          <span style="padding:0.1em;">Twistock</span>
        </p>
      </h1>
      <div class="content">
        <p>
          <span class="has-text-danger has-text-weight-bold">Twistock（ついすとっく）</span>は、いいねしたツイートや話題のツイートから、後から見返したいツイートを整理して、自分だけのストックを作成するWebアプリです。
        </p>
      </div>
      <b-button type="is-primary" @click="startApp" expanded>
          始める
      </b-button>
      <b-button tag="router-link" to="/stock/2008112349355315" expanded>
          ストックの例を見る
      </b-button>
    </div>
    <div class="columns image_show">
      <div class="column">
        <video src="/mp4/twistock_discription.mp4" controls></video>
      </div>
      <div class="column">
        <video src="/mp4/twistock_favorite.mp4" controls></video>
      </div>
      <div class="column">
        <video src="/mp4/twistock_ranking.mp4" controls></video>
      </div>
    </div>
    <b-button class="is-hidden-tablet" @click="startApp" type="is-primary" expanded>
        始める
    </b-button>
  </div>
</template>

<script>
import firebase from '@/firebase'

export default {
  title: " ",
  methods:{
    async startApp() {
      try{
        await firebase.login()
        if(this.$store.getters.isLogin == true) {
          this.$router.push({path:'/user'}).catch(()=>{})
          return
        }
        const unwatch = this.$store.watch((state, getters) => getters.isLogin, () => {
          unwatch()
          this.$router.push({path:'/user'}).catch(()=>{}) 
        })
      }
      catch (e) {
        console.erroe(e)
      }
    },
  }
}
</script>

<style scoped>
.image_show {
  margin-top: 1em;
}
</style>